import { emitter } from 'shared/helpers/mitt';
import analyticsHelper from 'dashboard/helper/AnalyticsHelper/index';

/**
 * Custom hook to track events
 */
export const useTrack = (...args) => {
  try {
    return analyticsHelper.track(...args);
  } catch (error) {
    // Ignore this, tracking is not mission critical
  }

  return null;
};

/**
 * Emits a toast message event using a global emitter.
 * @param {string} message - The message string
 * @param {Object|null} options - Optional options object with type, action, description, etc.
 */
export const useAlert = (message, options = null) => {
  if (!options) {
    emitter.emit('newToastMessage', {
      message,
      type: 'info',
      action: null,
      description: null,
    });
    return;
  }

  // Extract options
  const {
    type = 'info',
    action = null,
    description = null,
    persist = false,
  } = options;

  emitter.emit('newToastMessage', {
    message,
    type,
    action,
    description,
    persist,
  });
};